/* eslint-disable require-jsdoc */
import { useState, useEffect, useCallback, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { Viewer } from '../library/viewer'
import { retrieveProduct } from './dataRetrieval'
import { renderMaterialOptions } from './materialOptions'

// Fetch hook met cancellation als er snel een nieuwe set opgevraagd zou worden
const useProductData = (modelId) => {
  const [productData, setProductData] = useState([])

  useEffect(() => {
    let cancelled = false
    retrieveProduct(modelId)
      .then((response) => {
        let data = []
        if (
          response?.records[0]?.fields &&
          Object.keys(response.records[0].fields).includes(
            'Step file (from Step file)',
          )
        ) {
          let modelName =
            response.records[0].fields['Step file (from Step file)'][0].filename
          modelName = modelName.replace('.stp', '')
          data.push({
            modelCode: modelName,
            materialData: [],
            crossSellData: [],
            modelData: response.records[0],
          })
        }
        if (!cancelled) setProductData(data || [])
      })
      .catch(() => {
        if (!cancelled) setProductData([])
      })
    return () => {
      cancelled = true
    }
  }, [modelId])

  return productData
}

// // wrapper voor MaterialOptions om niet teveel hooks te callen in React
// function MaterialOptionsWrapper({
//   product,
//   selectedProductVariant,
//   onUpdate,
//   onToggle,
// }) {
//   return renderMaterialOptions(
//     product,
//     selectedProductVariant,
//     onUpdate,
//     onToggle,
//   )
// }

function ModelDetail() {
  const { modelId } = useParams()
  const productData = useProductData(modelId)

  // actieve variant
  // const [selectedProductVariant, setSelectedProductVariant] = useState([])

  // hidden xsells door toggle
  // const [hiddenVariants, setHiddenVariants] = useState([]) // array van modelCode strings

  //const [environment, setEnvironment] = useState('brown_photostudio_05_1k')
  //const [textureResolution, setTextureResolution] = useState('medium')
  const [viewerError, setViewerError] = useState(null)
  const [viewerReady, setViewerReady] = useState(false)

  // viewer error handler
  const handleViewerError = useCallback((error) => {
    console.error('Viewer error:', error)
    setViewerError(error)
  }, [])

  // viewer ready handler
  const handleViewerReady = useCallback(() => {
    console.log('🕺 Viewer ready!!')
    setViewerReady(true)
    if (
      typeof window !== 'undefined' &&
      typeof window.PUPPETEER_DATA !== 'undefined'
    )
      window.dispatchEvent(
        new CustomEvent('viewerReady', {
          detail: window.PUPPETEER_DATA,
        }),
      )
  }, [])

  // viewer capture handler
  const handleViewerCapture = useCallback(
    (pixels) => {
      console.log('📸 Viewer captured')

      const link = document.createElement('a')
      link.href = pixels
      link.download = `${modelId}_captured_image.jpg`
      link.click()
    },
    [modelId],
  )

  // default variants bij pageload en inladen van productData
  // useEffect(() => {
  //   if (!productData.length) return
  //
  //   const initVariants = async () => {
  //     const variants = await Promise.all(productData.map(createInitialVariant))
  //     setSelectedProductVariant(variants)
  //
  //     // reset checks
  //     const nodes = document.querySelectorAll?.('.component-data') || []
  //     nodes.forEach((node) => node.classList?.add?.('checked'))
  //
  //     // je krijgt de hiddenVariants mee via PUPPETEER, bv. hiddenXsells: [ 'PILFOLF' ]
  //     if (
  //       typeof window !== 'undefined' &&
  //       typeof window.PUPPETEER_DATA !== 'undefined' &&
  //       typeof window.PUPPETEER_DATA.hiddenXsells !== 'undefined'
  //     ) {
  //       setHiddenVariants(window.PUPPETEER_DATA.hiddenXsells)
  //     } else {
  //       setHiddenVariants([]) // leeg by default
  //     }
  //   }
  //
  //   initVariants()
  // }, [productData])

  // maak een eerste variant voor een product + Puppeteer overrides
  // const createInitialVariant = async (product) => {
  //   // return {
  //   //   modelCode: product.modelCode,
  //   //   materialData: [],
  //   //   crossSellData: [],
  //   // }
  //
  //   // if (product.materialData) {
  //   //   initialVariant.materialData = Object.values(
  //   //     product.materialData.reduce((acc, material) => {
  //   //       let can_add = true
  //   //       if (
  //   //         typeof window !== 'undefined' &&
  //   //         typeof window.PUPPETEER_DATA !== 'undefined' &&
  //   //         typeof window.PUPPETEER_DATA.materials !== 'undefined' &&
  //   //         (Object.keys(window.PUPPETEER_DATA.materials).includes(
  //   //           product.modelCode + '_' + material.type,
  //   //         ) ||
  //   //           Object.keys(window.PUPPETEER_DATA.materials).includes(
  //   //             material.type,
  //   //           ))
  //   //       ) {
  //   //         can_add = false
  //   //
  //   //         const productKey =
  //   //           window.PUPPETEER_DATA.materials[
  //   //             product.modelCode + '_' + material.type
  //   //           ]
  //   //         const typeKey = window.PUPPETEER_DATA.materials[material.type]
  //   //         if (productKey === material.code || typeKey === material.code) {
  //   //           can_add = true
  //   //         }
  //   //       }
  //   //
  //   //       if (can_add) {
  //   //         acc[material.type] = acc[material.type] || []
  //   //         acc[material.type].push(material)
  //   //       }
  //   //       return acc
  //   //     }, {}),
  //   //   ).map((group) => group.sort(() => 0.5 - Math.random())[0])
  //   // }
  //   //
  //   // if (product.crossSellData) {
  //   //   initialVariant.crossSellData = product.crossSellData.map(
  //   //     (crossSellProduct) => {
  //   //       const crossSellVariant = {
  //   //         modelCode: crossSellProduct.modelCode,
  //   //         materialData: [],
  //   //       }
  //   //
  //   //       if (crossSellProduct.materialData) {
  //   //         crossSellVariant.materialData = Object.values(
  //   //           crossSellProduct.materialData.reduce((acc, material) => {
  //   //             let can_add = true
  //   //             if (
  //   //               typeof window !== 'undefined' &&
  //   //               typeof window.PUPPETEER_DATA !== 'undefined' &&
  //   //               typeof window.PUPPETEER_DATA.materials !== 'undefined' &&
  //   //               (Object.keys(window.PUPPETEER_DATA.materials).includes(
  //   //                 crossSellProduct.modelCode + '_' + material.type,
  //   //               ) ||
  //   //                 Object.keys(window.PUPPETEER_DATA.materials).includes(
  //   //                   material.type,
  //   //                 ))
  //   //             ) {
  //   //               can_add = false
  //   //
  //   //               const productKey =
  //   //                 window.PUPPETEER_DATA.materials[
  //   //                   crossSellProduct.modelCode + '_' + material.type
  //   //                 ]
  //   //               const typeKey = window.PUPPETEER_DATA.materials[material.type]
  //   //               if (
  //   //                 productKey === material.code ||
  //   //                 typeKey === material.code
  //   //               ) {
  //   //                 can_add = true
  //   //               }
  //   //             }
  //   //
  //   //             if (can_add) {
  //   //               acc[material.type] = acc[material.type] || []
  //   //               acc[material.type].push(material)
  //   //             }
  //   //             return acc
  //   //           }, {}),
  //   //         ).map((group) => group.sort(() => 0.5 - Math.random())[0])
  //   //       }
  //   //       return crossSellVariant
  //   //     },
  //   //   )
  //   // }
  //
  //   // return initialVariant
  // }

  // update material handler, alleen als de container checked heeft als class
  // const handleMaterialUpdate = useCallback(
  //   (event, type, material, modelCode) => {
  //     event?.preventDefault?.()
  //     const wrapper = event?.target?.closest?.('.component-data')
  //     if (wrapper && wrapper.classList?.contains('checked')) {
  //       try {
  //         console.log(
  //           '☝️ User clicked:',
  //           type,
  //           material.id,
  //           material.code,
  //           modelCode,
  //         )
  //         const newMaterialData = material
  //         setSelectedProductVariant((prev) => {
  //           const updated = structuredClone(prev)
  //           findAndUpdateMaterialData(modelCode, type, newMaterialData, updated)
  //           return updated
  //         })
  //       } catch (error) {
  //         console.error('❌ Error updating material data:', error)
  //       }
  //     } else {
  //       console.log('❌ Clicked trigger blocked')
  //     }
  //   },
  //   [],
  // )

  // xsell toggle om te tonen of niet, handler
  // const handleToggleComponent = useCallback((componentCode, include) => {
  //   setHiddenVariants((prevHidden) => {
  //     const set = new Set(prevHidden)
  //     if (!include) set.add(componentCode)
  //     else set.delete(componentCode)
  //     return Array.from(set)
  //   })
  // }, [])

  // vind & update materials in geneste structuren
  // const findAndUpdateMaterialData = (
  //   modelCode,
  //   type,
  //   newMaterialData,
  //   variants,
  // ) => {
  //   for (const variant of variants) {
  //     if (variant.modelCode === modelCode) {
  //       variant.materialData = variant.materialData.map((m) =>
  //         m.type === type ? newMaterialData : m,
  //       )
  //       return true
  //     }
  //     if (
  //       variant.crossSellData &&
  //       findAndUpdateMaterialData(
  //         modelCode,
  //         type,
  //         newMaterialData,
  //         variant.crossSellData,
  //       )
  //     ) {
  //       return true
  //     }
  //   }
  //   return false
  // }

  // filter de data die effectief naar de viewer gaat en houd rekening met hidden xsells
  // const filteredSelectedProductVariant = useMemo(() => {
  //   if (!selectedProductVariant.length) return []
  //   if (!hiddenVariants.length) return selectedProductVariant
  //   const hidden = new Set(hiddenVariants)
  //   const cloned = structuredClone(selectedProductVariant)
  //   if (cloned[0]?.crossSellData?.length) {
  //     cloned[0].crossSellData = cloned[0].crossSellData.filter(
  //       (xsell) => !hidden.has(xsell.modelCode),
  //     )
  //   }
  //   return cloned
  // }, [selectedProductVariant, hiddenVariants])

  // shadows var met Puppeteer override, default true
  const shadows = useMemo(() => {
    if (
      typeof window !== 'undefined' &&
      typeof window.PUPPETEER_DATA !== 'undefined' &&
      typeof window.PUPPETEER_DATA.shadows !== 'undefined'
    ) {
      return window.PUPPETEER_DATA.shadows
    }
    return true
  }, [])

  if (!productData.length) {
    return <div className="loading-screen">Waiting for API...</div>
  }

  return (
    <>
      {!viewerReady && (
        <div className="loading-screen">Downloading assets...</div>
      )}
      <div
        id="canvas-container"
        style={{
          display: 'flex',
          flexDirection: 'row',
          maxHeight: '100vh',
          position: 'relative',
        }}
      >
        {viewerError ? (
          <div className="viewer-error">Error: {viewerError}</div>
        ) : (
          <>
            <Viewer
              productData={productData}
              onViewerReady={handleViewerReady}
              onViewerError={handleViewerError}
              className="viewer"
              containerClassName="viewer-container"
              onCapture={
                typeof window !== 'undefined' &&
                typeof window.PUPPETEER_DATA !== 'undefined' &&
                typeof window.PUPPETEER_DATA.capture !== 'undefined'
                  ? handleViewerCapture
                  : false
              }
              castShadow={shadows}
            />
          </>
        )}
      </div>

      <a
        className={'back-button'}
        href="/"
        style={{
          opacity: viewerReady ? 1 : 0,
        }}
      >
        Back
      </a>
    </>
  )
}

export default ModelDetail
